import { useOpenBotId, useSdkFeature } from '../../../store/app'
import { useBotConfiguration } from '../../serverBots'
import { hostingVersionsApi } from '../hostingVersionsApi'

export const useHostingUpdateHistoryForCurrentBot = () => {
  const botId = useOpenBotId()
  const config = useBotConfiguration()!

  // @ts-ignore
  const doesHostingSupportUpdateHistory = useSdkFeature('UPDATE_AND_DEPLOY_HISTORY')

  return hostingVersionsApi.endpoints.getHostingUpdateHistory.useQuery(
    { botId: botId! },
    { skip: !botId || !doesHostingSupportUpdateHistory || !config?.apiUrl }
  )
}
